import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "swiper/css";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainLayout from "./components/layout";
import LeaderboardScreen from "./components/LeaderboardScreen";
import OtpScreen from "./pages/OtpScreen";
import PhoneNumberScreen from "./pages/PhoneNumberScreen";
import SongPartsScreen from "./pages/SongPartsScreen";
import WelcomeScreen from "./pages/WelcomeScreen";
import WheelScreen from "./pages/WheelScreen";
import ReactQueryProvider from "./providers/ReactQueryProvider";
import OtpActivationScreen from "./pages/OtpActivationScreen";

function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ReactQueryProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<MainLayout />}>
              <Route path="/" element={<WelcomeScreen />} />
              <Route path="/auth/enter-phone" element={<PhoneNumberScreen />} />
              <Route path="/auth/enter-otp" element={<OtpScreen />} />
              <Route path="/vote/song" element={<LeaderboardScreen />} />
              <Route path="/song-details" element={<SongPartsScreen />} />
              <Route path="/otp-activation" element={<OtpActivationScreen />} />
              <Route path="/wheel" element={<WheelScreen />} />
              <Route path="*" element={<Navigate to="/404" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ReactQueryProvider>
    </>
  );
}

export default App;
